import { slugifyString } from '@/helpers'

export function getBlogCategoryHref(categoryName?: string | null) {
  if (!categoryName) return null

  const slug = slugifyString(categoryName)

  if (slug === 'articles') {
    return '/articles/'
  }

  return `/blog/category/${slug}/`
}
